export const checkValidTournaments = (tournament) => {
    return (
        tournament.homeTeam &&
        tournament.awayTeam &&
        (tournament.marketList.length || tournament.marketCount)
    );
};

export const getFilteredPreEvents = (
    preEventsBySportAndTime,
    sportId,
    rangeKey
) => {
    const preEvents = preEventsBySportAndTime[sportId]?.[rangeKey];

    return preEvents ? preEvents.filter(checkValidTournaments) : [];
};

export const searchTeamsByText = (item, searchText) => {
    return (
        item?.homeTeam?.toLowerCase()?.includes(searchText.toLowerCase()) ||
        item?.awayTeam?.toLowerCase()?.includes(searchText.toLowerCase()) ||
        item?.groupName?.toLowerCase()?.includes(searchText.toLowerCase()) ||
        item?.competition?.toLowerCase()?.includes(searchText.toLowerCase())
    );
};
